// src/pages/RenameTablePage.js
import React, { useState } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";

import PageHeader from "./components/PageHeader";
import TableList from "./components/TableList";
import TableForm from "./components/TableForm";
import { useTables } from "./components/useTables";
import { useUser } from "../UserContext";

import "react-toastify/dist/ReactToastify.css";
import "../../css/DBTablePage.css";


function RenameTablePage() {

  const { role } = useUser(); // Ottieni il ruolo dell’utente loggato
  
  const [selectedOldTable, setSelectedOldTable] = useState("");
  const [newTableName, setNewTableName] = useState("");

  const API_URL = process.env.REACT_APP_API_URL;
  const { tables, fetchTables } = useTables(API_URL);

  const isButtonEnabled =
    selectedOldTable &&
    newTableName.trim().length > 0 &&
    /^[a-zA-Z0-9_]+$/.test(newTableName.trim());

  const handleRename = async (e) => {
    e.preventDefault();

    if (!selectedOldTable) return toast.warning("Seleziona una tabella da rinominare.");
    if (!isButtonEnabled) return toast.warning("Nome nuovo non valido.");

    const trimmedName = newTableName.trim();
    const existing = tables.map((t) => t.name.toLowerCase());
    if (existing.includes(trimmedName.toLowerCase()))
      return toast.warning("Esiste già una tabella con questo nome.");

    const formData = new URLSearchParams();
    formData.append("oldTableName", selectedOldTable);
    formData.append("newTableName", trimmedName);

    try {
      const res = await fetch(`${API_URL}/renameTableDB`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData.toString(),
      });

      if (!res.ok) throw new Error("Errore durante la rinomina della tabella");

      toast.success(`Tabella "${selectedOldTable}" rinominata in "${trimmedName}"`);
      setSelectedOldTable("");
      setNewTableName("");
      fetchTables();
    } catch (err) {
      console.error(err);
      toast.error(err.message || "Errore imprevisto");
    }
  };

  // Se utente non loggato, mostra solo un messaggio
  if (!role) {
    return (
      <Container className="mt-5 text-center">
        <h5>Effettua il login per effettuare l'operazione</h5>
      </Container>
    );
  }
  


  return (
    <Container className="mt-5">
      <ToastContainer position="top-right" autoClose={3000} />
      <PageHeader title="Aggiornamento nome tabella" />

      <Row className="mt-5 mb-5 justify-content-center align-items-stretch g-4">
        {/* Colonna sinistra: elenco tabelle */}
        <Col xs={12} md={6}>
          <TableList tables={tables} />
        </Col>

        {/* Colonna destra: form rinomina */}
        <Col xs={12} md={6}>
          <TableForm
            title="✏️ Rinomina una tabella"
            onSubmit={handleRename}
            buttonLabel="RINOMINA TABELLA"
            buttonDisabled={!isButtonEnabled}
          >
            <Form.Group controlId="selectOldTable" className="mb-4">
              <Form.Label><strong>Tabella da rinominare</strong></Form.Label>
              <Form.Select
                value={selectedOldTable}
                onChange={(e) => setSelectedOldTable(e.target.value)}
              >
                <option value="">-- Seleziona una tabella --</option>
                {tables.map((item) => (
                  <option key={item.name} value={item.name}>
                    {item.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group controlId="newTableName">
              <Form.Label><strong>Nuovo nome tabella</strong></Form.Label>
              <Form.Control
                type="text"
                placeholder="Inserisci nuovo nome tabella"
                value={newTableName}
                onChange={(e) => setNewTableName(e.target.value)}
              />
            </Form.Group>
          </TableForm>
        </Col>
      </Row>
    </Container>
  );
}

export default RenameTablePage;
